import { SelectInputV2 } from '@frontend/components/basic-forms';

export interface EnumFieldProps {
    onChange: (value: string | null) => void;
    value: string | null;
    disabled?: boolean;
    className?: string;
    label?: React.ReactNode;
    required?: boolean;
    options?: string[];
}

export const EnumField = (props: EnumFieldProps) => {
    return (
        <SelectInputV2
            {...props}
            label={props.label || 'Enum Field'}
            options={props.options ? props.options.map((option) => ({ value: option, label: option })) : []}
            isClearable
            onSelect={(v) => props.onChange(v ? v.value : null)}
        />
    );
};
